import * as React from "react";
import prefillProps from "../../../util/prefillProps";
import Text, { TextProps } from "../../../elements/Text";
import styled from "styled-components";
import WithTooltip from "../../WithTooltip";

export function Title(props: TextProps) {
  const [doesOverflow, setOverflow] = React.useState(false);
  const textRef = React.useRef<HTMLDivElement>();

  React.useLayoutEffect(() => {
    const el = textRef.current!;

    if (el.scrollHeight > el.offsetHeight) {
      setOverflow(true);
    }
  }, []);

  if (doesOverflow) {
    return (
      <WithTooltip
        content={props.children as string}
        position={"top"}
        tooltipWidth={200}
      >
        <TitleBase {...props} />
      </WithTooltip>
    );
  }

  return <TitleBase ref={textRef} {...props} />;
}

const TitleBase = prefillProps<TextProps>(
  styled(Text)`
    line-height: initial;
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    margin-bottom: 3px;
  `,
  {
    fs: 0,
    fw: "bold",
    c: ["grey", 9]
  }
);

export const Subtitle = prefillProps<TextProps>(Text, {
  fs: -2,
  fw: "bold",
  c: ["grey", 5],
  style: { display: "block" }
});

export const Meta = prefillProps<TextProps>(Text, {
  c: ["grey", 5],
  style: { fontSize: 11 }
});
